import React from 'react'
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import {averageWaitTimeForQ} from '../Analitics_functions/Analitics';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const LineChart = ({ data, selectedQueues, dateRange }) => {
  const { startDate, endDate } = dateRange;

  const chartData = {
    labels: [],
    datasets: [],
  };

  // Generate date labels for the x-axis
  const currentDate = new Date(startDate);
  while (currentDate <= new Date(endDate)) {
    chartData.labels.push(currentDate.toISOString().split('T')[0]);
    currentDate.setDate(currentDate.getDate() + 1);
  }
  // Determine which queues to display
  const queuesToDisplay = selectedQueues.includes('all')
    ? Object.keys(data)
    : selectedQueues;

  // Generate datasets for each queue
  queuesToDisplay.forEach((queueId, index) => {
    const queueData = data[queueId];
    if (!queueData) {
      return;
    }

    const dataset = {
      label: queueData.queueName || queueData.name || `Queue ${queueId}`,
      data: chartData.labels.map((date) => {
        const dayStats = queueData.daily_stats[date];
        if (!dayStats || !dayStats.guests) return 0; // Use 0 for missing data to avoid null issues
        const result = averageWaitTimeForQ(dayStats);

        return result;
      }),
      borderColor: `hsl(${index * 137.5}, 50%, 50%)`,
      backgroundColor: `hsla(${index * 137.5}, 50%, 50%, 0.5)`,
      fill: false, // Ensure line chart doesn’t fill under the line
      tension: 0.4, // Smooth lines for better visuals
    };
    chartData.datasets.push(dataset);
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Average Wait Time by Queue',
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Average Wait Time (minutes)',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Date',
        },
      },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default LineChart;